





















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import ValidationService from "@/services/validationService";
import PasswordResetModel from "@/models/auth/passwordResetModel";
import authorisationService from "@/services/authorisationService";
import SnackbarModule from "@/store/snackbarModule";

const snackbarModule = getModule(SnackbarModule);

@Component
export default class ResetPassword extends Vue {
  @Prop(String) readonly id!: string;

  private readonly validationService: ValidationService = new ValidationService();
  private loading = false;
  private valid = false;
  private showPassword = false;
  private showConfirmPassword = false;

  private model: PasswordResetModel = new PasswordResetModel();

  get getPasswordsMatch() {
    return (
      this.model.password == this.model.confirmPassword || "Password must match"
    );
  }

  private async onResetSend() {
    if (!(this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      return;
    }

    try {
      this.loading = true;
      await authorisationService.postResetPassword(
        this.id,
        this.model.password
      );

      snackbarModule.snackSuccess("Password reset");
      this.$router.push({ name: "Login" });
    } catch {
      snackbarModule.snackError("Password reset failed");
    } finally {
      this.loading = false;
    }
  }
}
